/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2019-11-15 09:29:32
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2019-11-27 15:35:18
 */
import Vue from 'vue';
import message from './pi-message.vue';

const SuccessBoxConstructor = Vue.extend(message);

let getAnInstance = () => {
  return new SuccessBoxConstructor({
    el: document.createElement('div')
  });
};

let messageBox = (options = {}) => {
  let instance = getAnInstance();
  instance.title = options.title || options.title === '' ? options.title : '提示';
  instance.cancelText = options.cancelText || '取消';
  instance.isCancel = options.isCancel !== undefined ? options.isCancel : true;
  instance.confirmActive = options.confirmActive !== undefined ? options.confirmActive : false;
  instance.confirmText = options.confirmText || '确定';
  instance.text = options.text || '';
  instance.textActive = options.textActive !== undefined ? options.textActive : true;

  instance.confirmFn = () => {
    colse();
    options.confirm && options.confirm();
  };
  instance.cancelFn = () => {
    options.cancel && options.cancel();
    colse();
  };

  let colse = async () => {
    instance.divShow = false;
    setTimeout(() => {
      instance.$el.parentNode.removeChild(instance.$el);
    }, 400);
  };

  document.body.appendChild(instance.$el);
};

export default messageBox;
